var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.75C5.57 21.75 0.75 16.93 0.75 11C0.75 5.07 5.57 0.25 11.5 0.25C17.43 0.25 22.25 5.07 22.25 11C22.25 16.93 17.43 21.75 11.5 21.75ZM11.5 1.75C6.4 1.75 2.25 5.9 2.25 11C2.25 16.1 6.4 20.25 11.5 20.25C16.6 20.25 20.75 16.1 20.75 11C20.75 5.9 16.6 1.75 11.5 1.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonIcon);
export default __webpack_public_path__ + "static/media/radio-button-icon.cf35d75046ccf004206c99207cdb75c9.svg";
export { ForwardRef as ReactComponent };